var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaboratorniIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.5,9.5c0-0.6,0-6.5,0-6.5h-5c0,0,0,5.7,0,6.5c-3,1-5,3.7-5,7c0,4.1,3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5 C19.5,13.2,17.4,10.5,14.5,9.5z M10.5,15.5C8.3,15.4,7.9,16.3,6,17c0-3.6,2.3-5.5,4.9-6.4C11,9.8,11,4.5,11,4.5h2c0,0,0,5.5,0,6 c2.6,0.9,5.3,2.9,5,7.5C14.8,19.8,13.2,15.6,10.5,15.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    className: "st0",
    width: 7,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaboratorniIcon);
export default __webpack_public_path__ + "static/media/laboratorni_icon.53f1c7b0.svg";
export { ForwardRef as ReactComponent };